import Radium from '@flipdish/radium';
import * as React from 'react';
import { findDOMNode } from 'react-dom';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { hashHistory, Link } from 'react-router';
import { Track } from '../../analytics';
import { AppConfig, AppDesignScheme, CollectionRestaurantSummary, Customer } from '../../Api';
import { Async } from '../../Data';
import * as Store from '../../Store';
import { Utilities } from '../../Utilities';
import PermissionConsentDialog from '../PermissionConsentDialog';
import { MainLayout } from '../MainLayout/MainLayout';
const tinycolor = require('tinycolor2');

interface DispatchProps {}

interface StateProps {
  LastRestaurantUrl: string;
  AppConfig: Async<AppConfig>;
  CollectionSummaries: Async<CollectionRestaurantSummary[]>;
  Customer: Async<Customer>;
  translate: any;
  AppDesignScheme: AppDesignScheme;
  isDark: boolean;
}

type Props = StateProps & DispatchProps;

interface State {}

class Where extends React.Component<Props, State> {
  public componentDidMount() {
    Utilities.ensureVisible(findDOMNode(this));
  }

  public renderBackLink(): JSX.Element | null {
    const { LastRestaurantUrl, translate, AppDesignScheme, isDark } = this.props;

    if (LastRestaurantUrl == '/') {
      return null;
    }

    const styles = {
      nav: {
        ':hover': {},
        ':active': {}
      },
      secondaryActive: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      secondaryHover: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString()
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      },
      primary: {
        color: AppDesignScheme.Primary
      }
    };

    return (
      <Link to={this.props.LastRestaurantUrl}>
        <div key="fd-nav" className="fd-nav flex flex-align-center" style={styles.nav as any}>
          <i
            className="arrow_carrot-left tertiary"
            style={
              Radium.getState(this.state, 'fd-nav', ':active')
                ? styles.secondaryActive
                : Radium.getState(this.state, 'fd-nav', ':hover')
                ? styles.secondaryHover
                : isDark
                ? styles.primary
                : styles.tertiary
            }
            aria-hidden="true"
          />
          <p
            className="inline-block clear-margins tertiary bold"
            style={
              Radium.getState(this.state, 'fd-nav', ':active')
                ? styles.secondaryActive
                : Radium.getState(this.state, 'fd-nav', ':hover')
                ? styles.secondaryHover
                : isDark
                ? styles.primary
                : styles.tertiary
            }
          >
            <u>{translate('Back_to_menu')}</u>
          </p>
        </div>
      </Link>
    );
  }

  public collectionLink(): string {
    const { AppConfig, CollectionSummaries } = this.props;

    switch (AppConfig.status) {
      case 'success':
        break;
      default:
        return '/collection';
    }

    if (AppConfig.data.DisplayPickupRestaurantListScreen) {
      return '/collection';
    }

    if (CollectionSummaries.status != 'success') {
      return '/collection';
    }

    if (CollectionSummaries.data.length > 0) {
      return (
        '/restaurant/' +
        CollectionSummaries.data[0].VirtualRestaurantId +
        '/collection/' +
        CollectionSummaries.data[0].PhysicalRestaurantId
      );
    }

    const [skip] = CollectionSummaries.data.filter((c) => c.SkipToThisPhysicalRestaurant);

    if (!skip) {
      return '/collection';
    }

    return '/restaurant/' + skip.VirtualRestaurantId + '/collection/' + skip.PhysicalRestaurantId;
  }

  public trackDelivery(): any {
    Track('Maps', 'Delivery Selected');
  }

  public trackCollection(): any {
    Track('Maps', 'Collection Selected');
  }

  public render(): JSX.Element {
    const { AppConfig, CollectionSummaries, translate, AppDesignScheme, isDark } = this.props;

    if (AppConfig.status != 'success') {
      return null;
    }

    if (AppConfig.status == 'success') {
      if (!AppConfig.data.PickupEnabled) {
        hashHistory.replace('/delivery');
      }
      if (!AppConfig.data.DeliveryEnabled && CollectionSummaries.status == 'success') {
        // TODO - there is a race condition here.
        // This redirect can happen before have downloaded the collection
        // restaurant summaries.
        hashHistory.replace(this.collectionLink());
      }
    }

    const styles = {
      primary: {
        color: AppDesignScheme.Primary,
        borderColor: AppDesignScheme.Primary
      },
      primaryAlt: {
        color: AppDesignScheme.Primary,
        borderColor: AppDesignScheme.Secondary
      },
      secondary: {
        color: AppDesignScheme.Secondary
      },
      tertiary: {
        color: AppDesignScheme.Tertiary,
        borderColor: AppDesignScheme.Tertiary
      },
      option: {
        borderColor: AppDesignScheme.Secondary,
        ':hover': {
          boxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`
        }
      },
      darkOption: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString()}`,
        ':hover': {
          borderColor: AppDesignScheme.Secondary,
          boxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`
        }
      },
      mask: {
        backgroundColor: AppDesignScheme.Primary
      },
      darkMask: {
        backgroundColor: AppDesignScheme.Tertiary
      },
      maskHover: {
        backgroundColor: AppDesignScheme.Secondary
      }
    };

    return (
      <MainLayout>
        <div className="container">
          <div className="row where">
            <div className="col-md-12">
              <h1
                id="skip-to-content"
                tabIndex={0}
                className="secondary sm-center"
                style={isDark ? styles.primary : styles.secondary}
              >
                {translate('How_do_you_want_to_order')}
              </h1>
              {this.renderBackLink()}
            </div>
            <div className="col-md-6">
              <Link to="/delivery" onClick={this.trackDelivery} data-fd="where-delivery">
                <div
                  key="option-delivery"
                  className="where__option where__option--delivery"
                  style={isDark ? (styles.darkOption as any) : (styles.option as any)}
                >
                  <div
                    className="where__option__mask"
                    style={
                      Radium.getState(this.state, 'option-delivery', ':hover')
                        ? styles.maskHover
                        : isDark
                        ? styles.darkMask
                        : styles.mask
                    }
                  />
                  <div className="col-xs-3 where__option__icon fill-height flex flex-align-center flex-justify-end">
                    <i
                      className="icon_pin secondary"
                      style={
                        Radium.getState(this.state, 'option-delivery', ':hover')
                          ? styles.primary
                          : isDark
                          ? styles.primary
                          : styles.secondary
                      }
                      aria-hidden="true"
                    />
                  </div>
                  <div className="col-xs-9 where__option__info fill-height flex flex-column flex-align-start flex-justify-center">
                    <h2
                      className="tertiary clear-margins"
                      style={
                        Radium.getState(this.state, 'option-delivery', ':hover')
                          ? styles.primary
                          : isDark
                          ? styles.primaryAlt
                          : styles.tertiary
                      }
                    >
                      {translate('Delivery')}
                    </h2>
                    <p
                      className="tertiary clear-margins fd-h4"
                      style={
                        Radium.getState(this.state, 'option-delivery', ':hover')
                          ? styles.primary
                          : isDark
                          ? styles.primary
                          : styles.tertiary
                      }
                    >
                      {translate('I_want_to_order_for_delivery')}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-md-6">
              <Link
                to={this.collectionLink()}
                onClick={this.trackCollection}
                data-fd="where-collection"
              >
                <div
                  key="option-collection"
                  className="where__option where__option--collection"
                  style={isDark ? (styles.darkOption as any) : (styles.option as any)}
                >
                  <div
                    className="where__option__mask"
                    style={
                      Radium.getState(this.state, 'option-collection', ':hover')
                        ? styles.maskHover
                        : isDark
                        ? styles.darkMask
                        : styles.mask
                    }
                  />
                  <div className="col-xs-3 where__option__icon fill-height flex flex-align-center flex-justify-end">
                    <i
                      className="fa fa-shopping-basket secondary"
                      style={
                        Radium.getState(this.state, 'option-collection', ':hover')
                          ? styles.primary
                          : isDark
                          ? styles.primary
                          : styles.secondary
                      }
                      aria-hidden="true"
                    />
                  </div>
                  <div className="col-xs-9 where__option__info fill-height flex flex-column flex-align-start flex-justify-center">
                    <h2
                      className="tertiary clear-margins"
                      style={
                        Radium.getState(this.state, 'option-collection', ':hover')
                          ? styles.primary
                          : isDark
                          ? styles.primaryAlt
                          : styles.tertiary
                      }
                    >
                      {AppConfig.data.DineInEnabled && !AppConfig.data.PickupEnabled
                        ? translate('Dine_in')
                        : AppConfig.data.DineInEnabled && AppConfig.data.PickupEnabled
                        ? `${this.props.translate('Collect')}/${this.props.translate('Dine_in')}`
                        : translate('Collection')}
                    </h2>
                    <p
                      className="tertiary clear-margins fd-h4"
                      style={
                        Radium.getState(this.state, 'option-collection', ':hover')
                          ? styles.primary
                          : isDark
                          ? styles.primary
                          : styles.tertiary
                      }
                    >
                      {AppConfig.data.DineInEnabled && !AppConfig.data.PickupEnabled
                        ? translate('I_want_to_dine_in')
                        : AppConfig.data.DineInEnabled && AppConfig.data.PickupEnabled
                        ? translate('I_want_to_collect_dine_in')
                        : translate('I_want_to_collect_my_order')}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
          <PermissionConsentDialog />
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (s: Store.State): StateProps => {
  return {
    LastRestaurantUrl: s.flipdish.LastRestaurantUrl,
    AppConfig: s.flipdish.AppConfig,
    CollectionSummaries: s.flipdish.CollectionSummaries,
    Customer: s.flipdish.Customer,
    translate: getTranslate(s.locale),
    AppDesignScheme: s.appDesignScheme,
    isDark: s.flipdish.isDark
  };
};

const mapDispatchToProps = (dispatch: any): DispatchProps => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Radium(Where));
